var map = {
	"./poly-1.png": "9de0",
	"./poly-10.png": "2a88",
	"./poly-2.png": "4265",
	"./poly-3.png": "8608",
	"./poly-4.png": "a2ef",
	"./poly-5.png": "ad22",
	"./poly-6.png": "e4a9",
	"./poly-7.png": "bd90",
	"./poly-8.png": "c7c5",
	"./poly-9.png": "3005"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1ce1";